import commonUtil from '../../../utils/commonUtil';

export const CONTENT_LOAD = 'MLP_CONTENT_LOAD';
export const CONTENT_LOAD_SUCCESS = 'MLP_CONTENT_LOAD_SUCCESS';
export const CONTENT_LOAD_FAIL = 'MLP_CONTENT_LOAD_FAIL';

export function isContentLoaded(globalState, page_id) {
  return (
    globalState.getMarketingLandingPage &&
    globalState.getMarketingLandingPage.loaded &&
    globalState.getMarketingLandingPage.page_id === page_id
  );
}

export function loadContent(page_id) {
  const _landingPageInput = {};
  _landingPageInput.brand = commonUtil.getBrand();
  _landingPageInput.channel = commonUtil.getChannel();
  _landingPageInput.page_id = page_id;
  let GetPram = getPayloadString(page_id);
  return {
    types: [CONTENT_LOAD, CONTENT_LOAD_SUCCESS, CONTENT_LOAD_FAIL],
    promise: (client) => client.get('/api/getMarketingLandingPage?' + GetPram),
  };
}
const getPayloadString = (page_id) => {
  const brand = commonUtil.getBrand().toUpperCase();
  const channel = commonUtil.getChannel().toUpperCase();
  return `brand=${brand}&channel=${channel}&page_id=${page_id}`;
};
